import _defineProperty from "/jove-quote/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _toConsumableArray from "/jove-quote/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/toConsumableArray.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { isArray } from 'lodash';
import { getSupportRegionMap } from '../constants';
import { AmericanCountryList, EuropeanUnionList, UKCountryList } from '../constants/quote';
export var getCountry2XLogoUrl = function getCountry2XLogoUrl(code) {
  if (!code) return '';
  return "https://flagcdn.com/w40/".concat(code.toLowerCase(), ".png 2x");
};
export var getCountryNormalLogoUrl = function getCountryNormalLogoUrl(code) {
  if (!code) return '';
  return "https://flagcdn.com/w20/".concat(code.toLowerCase(), ".png");
};
export var getCountryListByRegionAndCountries = function getCountryListByRegionAndCountries(regions, config) {
  var list = [];

  if (regions !== null && regions !== void 0 && regions.includes(getSupportRegionMap().GB.value)) {
    list.push.apply(list, _toConsumableArray(UKCountryList));
  }

  if (regions !== null && regions !== void 0 && regions.includes(getSupportRegionMap().US.value)) {
    list.push.apply(list, _toConsumableArray(AmericanCountryList));
  }

  if (regions !== null && regions !== void 0 && regions.includes(getSupportRegionMap().EU.value)) {
    list.push.apply(list, _toConsumableArray((config === null || config === void 0 ? void 0 : config.countryList) || []));
  }

  return list;
};
export var getAllSupportDisplayCountryListWithAllCountries = function getAllSupportDisplayCountryListWithAllCountries(countries) {
  var list = [];

  if (isArray(countries)) {
    var listMap = {}; // Data

    countries.forEach(function (item) {
      if ([].concat(_toConsumableArray(AmericanCountryList), _toConsumableArray(UKCountryList), _toConsumableArray(EuropeanUnionList)).includes(item.code)) {
        listMap[item.code] = _objectSpread({}, item);
      }
    }); // Sort

    [].concat(_toConsumableArray(AmericanCountryList), _toConsumableArray(UKCountryList), _toConsumableArray(EuropeanUnionList)).forEach(function (code) {
      if (listMap[code]) {
        list.push(listMap[code]);
      }
    });
  }

  return list;
};